<template>
  <b-badge
    v-if="text"
    class="sr-status-badge"
    pill
    :style="style"
  >
    {{ $tc(text) }}
  </b-badge>
</template>

<script>
import { VIRTUAL_SHELF_OPTIONS_GROSSING_SAMPLE } from '@/modules/grossingModule/services/grossingSampleService'

export default {
    name: 'SampleShelfBadge',
    props: {
        status: { type: [Number, String], required: false }
    },
    computed: {
        style() {
            return { 'background-color': this.statusOption.bgColor, color: this.color }
        },
        color() {
            return this.statusOption.color || '#686868'
        },
        text() {
            return this.statusOption.label
        },
        statusOption() {
            const option = VIRTUAL_SHELF_OPTIONS_GROSSING_SAMPLE.find(virtualShelfOption =>
                virtualShelfOption.key === this.status ||
                String(virtualShelfOption.key) === this.status ||
                virtualShelfOption.code === this.status)
            return option ?? { key: 0, label: '', bgColor: 'rgba(255,255,255,0)', color: 'rgba(255,255,255,0)' }
        }
    }
}
</script>

<style scoped lang="scss">
.sr-status-badge {
  width: 85px;
}
</style>
